export default {
  // Navigation
  nav_home: 'Inicio',
  nav_dashboard: 'Panel de Control',
  nav_orders: 'Pedidos',
  nav_wallet: 'Billetera',
  nav_analytics: 'Análisis',
  nav_referral: 'Referidos',
  nav_account: 'Cuenta',
  nav_notifications: 'Notificaciones',
  nav_logout: 'Cerrar sesión',
  nav_login: 'Iniciar sesión',
  nav_signup: 'Registrarse',
  nav_deposit_requests: 'Solicitudes de Depósito',
  nav_withdraw_requests: 'Solicitudes de Retiro',
  nav_support_ticket: 'Ticket de Soporte',
  nav_system_logs: 'Logs del Sistema',
  nav_announcements: 'Anuncios',
  nav_activity_logs: 'Logs de Actividad',
  nav_settings: 'Configuración',
  nav_section_main: 'Principal',
  nav_user_active: 'Activo ahora',
  nav_more: 'Más',
  nav_logout_confirm: '¿Estás seguro de que deseas cerrar sesión?',
  nav_language: 'Idioma',

  // Dashboard
  dashboard_welcome: 'Bienvenido de nuevo',
  dashboard_total_earnings: 'Ganancias Totales',
  dashboard_pending_orders: 'Pedidos Pendientes',
  dashboard_completed_orders: 'Pedidos Completados',
  dashboard_commission_rate: 'Tasa de Comisión',
  dashboard_quick_actions: 'Acciones Rápidas',
  dashboard_recent_orders: 'Pedidos Recientes',
  dashboard_recent_activity: 'Actividad Reciente',
  dashboard_wallet_balance: 'Saldo de Billetera',
  dashboard_deposit: 'Depositar',
  dashboard_withdraw: 'Retirar',
  dashboard_view_all: 'Ver Todo',
  greeting_morning: 'Buenos Días',
  greeting_afternoon: 'Buenas Tardes',
  greeting_evening: 'Buenas Noches',
  dashboard_greeting_desc: 'Sigue tus ganancias, completa pedidos y gestiona tu cuenta en un solo lugar. ¡Tu camino al éxito continúa aquí!',

  // Dashboard Stats
  stats_available_balance: 'Saldo Disponible',
  stats_total_withdrawn: 'Total Retirado',
  stats_total_deposit: 'Total Depositado',
  stats_pending_orders: 'Pedidos Pendientes',
  stats_orders_suffix: ' pedidos',
  stats_task_earnings: 'Ganancias de Tareas',
  stats_lifetime_earning: 'Ganancias Históricas',

  // Orders
  orders_title: 'Mis Pedidos',
  orders_all: 'Todos los Pedidos',
  orders_pending: 'Pendiente',
  orders_completed: 'Completado',
  orders_cancelled: 'Cancelado',
  orders_order_id: 'ID de Pedido',
  orders_platform: 'Plataforma',
  orders_amount: 'Monto',
  orders_commission: 'Comisión',
  orders_step_4: 'Enviar promoción',
  orders_step_5: 'Indexación SEO',
  orders_step_6: 'Impulsar visibilidad',
  orders_step_7: 'Finalización y confirmación',
  orders_btn_optimize: 'Optimizar pedido',
  orders_btn_claim_commission: 'Reclamar comisión',
  orders_btn_task_completed: 'Tarea completada',
  orders_price_label: 'Precio del pedido',
  orders_commission_rate_label: 'Tasa de comisión',
  orders_status: 'Estado',
  orders_date: 'Fecha',
  orders_no_orders: 'No se encontraron pedidos',

  // Wallet
  wallet_title: 'Mi Billetera',
  wallet_available_balance: 'Saldo Disponible',
  wallet_pending_balance: 'Saldo Pendiente',
  wallet_total_withdrawn: 'Total Retirado',
  wallet_deposit_now: 'Depositar Ahora',
  wallet_withdraw_now: 'Retirar Ahora',
  wallet_transaction_history: 'Historial de Transacciones',
  wallet_deposit_history: "Deposit History",
  wallet_withdrawal_history: 'Historial de Retiros',
  wallet_deposit_desc: "Agrega dinero a tu billetera usando métodos de pago disponibles.",
  wallet_no_deposits: "No se encontraron depósitos.",
  wallet_withdraw_history: "Historial de retiros",
  wallet_withdraw_desc: "Retira dinero de tu billetera.",
  wallet_no_withdrawals: "No se encontraron retiros.",
  wallet_no_withdrawals_desc: "Aún no has realizado ningún retiro.",
  withdrawal_restricted_title: 'Withdrawal Restricted',
  withdrawal_restricted_message: 'Withdrawals are currently unavailable for your account. Please contact customer support for more information.',

  // Analytics
  analytics_title: 'Análisis',
  analytics_earnings_overview: 'Resumen de Ganancias',
  analytics_platform_breakdown: 'Desglose por Plataforma',
  analytics_performance_metrics: 'Métricas de Rendimiento',
  analytics_top_products: 'Productos Top',
  analytics_this_month: 'Este Mes',
  analytics_last_month: 'Mes Pasado',
  analytics_total_revenue: 'Ingresos Totales',
  analytics_avg_order_value: 'Valor de Pedido Promedio',

  // Referral
  referral_title: 'Programa de Referidos',
  referral_your_code: 'Tu Código de Referido',
  referral_copy_code: 'Copiar Código',
  referral_share_link: 'Compartir Enlace',
  referral_total_referrals: 'Total de Referidos',
  referral_active_referrals: 'Referidos Activos',
  referral_referral_earnings: 'Ganancias por Referidos',
  referral_invite_friends: 'Invitar Amigos',

  // Account
  account_title: 'Configuración de Cuenta',
  account_profile: 'Perfil',
  account_security: 'Seguridad',
  account_notifications: 'Notificaciones',
  account_kyc: 'Verificación KYC',
  account_phone: 'Número de Teléfono',
  account_two_factor: 'Autenticación de Dos Factores',
  account_save_changes: 'Guardar Cambios',
  account_cancel: 'Cancelar',

  // Auth & Common
  auth_email: 'Correo Electrónico',
  auth_password: 'Contraseña',
  auth_confirm_password: 'Confirmar Contraseña',
  auth_forgot_password: '¿Olvidaste la contraseña?',
  auth_remember_me: 'Recordarme',
  auth_login_button: 'Iniciar Sesión',
  auth_signup_button: 'Registrarse',
  auth_already_have_account: '¿Ya tienes una cuenta?',
  auth_dont_have_account: "¿No tienes una cuenta?",
  auth_reset_password: 'Restablecer Contraseña',
  auth_verify_email: 'Verificar Correo',
  auth_live_platform: 'Plataforma en Vivo',
  auth_security_verification: 'Verificación de Seguridad',
  auth_captcha_refresh: 'Refrescar',
  auth_captcha_placeholder: 'Resultado',
  auth_captcha_error: 'Suma incorrecta, inténtalo de nuevo',
  auth_branding_title: 'Convierte Promociones en',
  auth_branding_highlight_prefix: '',
  auth_branding_highlight: 'Ingresos Reales',
  auth_branding_desc: 'Únete a miles de promotores que ganan comisiones diarias de las mejores marcas de comercio electrónico del mundo.',
  auth_sign_in_to_account: 'Inicia sesión en tu cuenta de {{system_name}} account',
  auth_email_placeholder: 'tu@ejemplo.com',
  auth_password_placeholder: 'Introduce tu contraseña',
  auth_signing_in: 'Iniciando sesión...',
  auth_free_to_join: 'Unirse es Gratis',
  auth_signup_branding_title: 'Empieza a Ganar',
  auth_signup_branding_highlight: 'Desde el Primer Día',
  auth_signup_branding_desc: 'No necesitas experiencia. Regístrate en 2 minutos y empieza a completar tareas para las mejores marcas de comercio electrónico.',
  auth_how_it_works: 'Cómo funciona',
  auth_signup_desc: '¡Únete a {{system_name}} y empieza a ganar comisiones hoy mismo, es gratis!',
  auth_step_1: 'Crea tu cuenta gratuita',
  auth_step_2: 'Explora y acepta tareas',
  auth_step_3: 'Completa y gana comisiones',
  auth_signup_step_1_title: 'Crear Cuenta',
  auth_signup_step_1_desc: 'Empieza tu viaje',
  auth_signup_step_2_title: 'Completa Tareas',
  auth_signup_step_2_desc: 'Gana comisiones diarias',
  auth_signup_step_3_title: 'Retirar Fondos',
  auth_signup_step_3_desc: 'Retiros rápidos y seguros',
  auth_benefit_1_title: 'Seguro y Confiable',
  auth_benefit_1_desc: 'Seguridad bancaria para tus ganancias',
  auth_benefit_2_title: 'Pagos Instantáneos',
  auth_benefit_2_desc: 'Retira ganancias en menos de 24 horas',
  auth_benefit_3_title: 'Comunidad Global',
  auth_benefit_3_desc: 'Únete a más de 12.000 promotores activos',
  auth_benefit_4_title: 'Soporte 24/7',
  auth_benefit_4_desc: 'Recibe ayuda cuando la necesites',
  auth_strength_weak: 'Débil',
  auth_strength_fair: 'Aceptable',
  auth_strength_good: 'Buena',
  auth_strength_strong: 'Fuerte',
  auth_password_strength: 'Fuerza de la contraseña: {{strength}}',
  auth_social_proof: 'Únete a más de {{count}} usuarios con ganancias',
  auth_passwords_match: 'Las contraseñas coinciden',
  auth_creating_account: 'Creando cuenta...',
  auth_phone_number: 'Número de Teléfono',
  auth_phone_optional: '(Opcional)',
  auth_phone_placeholder: 'Tu número de teléfono',
  auth_full_name: 'Nombre Completo',
  auth_full_name_placeholder: 'Juan Pérez',
  auth_password_min_chars: 'Mínimo 8 caracteres',
  auth_confirm_password_placeholder: 'Repite tu contraseña',
  auth_agree_to: 'Acepto los',
  auth_terms_of_service: 'Términos de Servicio',
  auth_privacy_policy: 'Política de Privacidad',
  auth_and: 'y la',
  auth_create_free_account: 'Crear Cuenta Gratis',

  common_loading: 'Cargando...',
  common_save: 'Guardar',
  common_cancel: 'Cancelar',
  common_delete: 'Eliminar',
  common_edit: 'Editar',
  common_view: 'Ver',
  common_search: 'Buscar',
  common_filter: 'Filtrar',
  common_export: 'Exportar',
  common_import: 'Importar',
  common_submit: 'Enviar',
  common_close: 'Cerrar',
  common_confirm: 'Confirmar',
  common_success: 'Éxito',
  common_error: 'Error',
  common_warning: 'Advertencia',
  common_announcement: 'Anuncio',

  val_full_name_required: 'El nombre completo es obligatorio',
  val_email_required: 'El correo electrónico es obligatorio',
  val_password_required: 'La contraseña es obligatoria',
  val_password_min: 'La contraseña debe tener al menos 8 caracteres',
  val_passwords_dont_match: 'Las contraseñas no coinciden',
  security_pin_6_err: 'El PIN debe tener exactamente 6 dígitos.',
  security_pin_digit_err: 'El PIN solo debe contener dígitos.',
  val_agree_terms: 'Debes aceptar los términos',
  val_conn_error: 'Error de conexión. Inténtalo de nuevo.',

  // Homepage
  home_hero_title: 'Gana Comisiones de las Mejores Plataformas de Comercio Electrónico',
  home_hero_subtitle: 'Únete a miles de usuarios que ganan comisiones diarias de Walmart, eBay y AliExpress',
  home_get_started: 'Empieza Ahora',
  home_learn_more: 'Saber Más',
  home_how_it_works: 'Cómo Funciona',
  home_features: 'Características',
  home_why_choose_us: 'Por qué elegirnos',
  home_features_title: 'Funciones Potentes',
  home_features_subtitle: 'Todo lo que necesitas para empezar a ganar online. Construido pensando en tu éxito.',
  home_commission_tiers: 'Niveles de Comisión',
  home_testimonials: 'Lo que dicen nuestros usuarios',
  home_faq: 'Preguntas Frecuentes',
  home_cta_title: '¿Listo para empezar a ganar?',
  home_cta_subtitle: 'Únete a nuestra comunidad hoy mismo y empieza a ganar comisiones',
  home_trusted_partner: 'Plataformas Asociadas de Confianza',
  home_secure_platform: 'Plataforma Segura',
  home_instant_payouts: 'Pagos Instantáneos',
  home_active_users: 'Usuarios Activos',
  home_paid_out: 'Pagado',
  home_total_paid_out: 'Total Pagado',
  home_user_rating: 'Calificación de Usuarios',
  home_countries: 'Países',
  home_commission_badge: 'Potencial de Ganancias',
  home_commission_title: 'Tasas de Comisión',
  home_commission_desc: 'Un saldo mayor desbloquea mejores tasas de comisión. Cada sesión asigna exactamente 25 pedidos — completa hasta 4 sesiones diarias para maximizar ganancias.',
  home_tier_popular: 'Más Popular',
  home_tier_commission_per_order: 'Comisión por Pedido',
  home_tier_earn_examples: 'Ejemplos de Ganancias:',
  home_tier_order: 'pedido',
  home_tier_batch_earn: 'Ganancia por lote de 25 pedidos:',
  home_tier_daily_potential: 'Potencial Diario (4 lotes × 25 pedidos)',
  home_tier_max_daily: 'Hasta 100 pedidos por día',
  home_tier_benefit_1: '25 pedidos por lote',
  home_tier_benefit_2: 'Máximo 4 lotes por día',
  home_tier_benefit_3: 'Crédito de comisión instantáneo',
  home_tier_above: 'Sobre',
  home_tier_no_tiers: 'No se encontraron niveles de comisión.',

  // Comparison Section
  home_compare_badge: 'La Diferencia',
  home_compare_title: 'Por Qué Somos Mejores',
  home_compare_subtitle: 'Compara nuestra plataforma con trabajos tradicionales de medio tiempo y mira por qué miles nos eligen.',
  home_compare_feature: 'Característica',
  home_compare_traditional: 'Trabajos Tradicionales',
  home_compare_our_platform: 'Nuestra Plataforma',
  home_compare_f1: 'Flexibilidad',
  home_compare_f1_trad: 'Horarios fijos',
  home_compare_f1_our: 'Trabaja en cualquier momento y lugar',
  home_compare_f2: 'Pagos',
  home_compare_f2_trad: 'Mensual o quincenal',
  home_compare_f2_our: 'Instantáneo / Mismo día',
  home_compare_f3: 'Requisitos',
  home_compare_f3_trad: 'Experiencia/CV/Entrevista',
  home_compare_f3_our: 'Ninguno - Solo un smartphone',
  home_compare_f4: 'Crecimiento',
  home_compare_f4_trad: 'Aumentos anuales fijos',
  home_compare_f4_our: 'Crecimiento ilimitado basado en niveles',

  // Testimonials
  home_testi_badge: 'Historias de Éxito',
  home_testi_title: 'Confiado por Miles',
  home_testi_subtitle: 'Escucha a nuestra comunidad global de promotores que han transformado sus ingresos.',
  home_testi_no_stories: 'Aún no hay historias de éxito disponibles.',
  home_testi_total_earned: 'Total Ganado',
  home_testi_time_period: 'Periodo de Tiempo',
  home_testi_verified: 'Usuario Verificado',
  home_testi_avg_rating: 'Calificación Promedio',
  home_testi_satisfaction_rate: 'Tasa de Satisfacción',
  home_testi_support_available: 'Soporte Disponible',

  // FAQ
  home_faq_badge: 'Soporte',
  home_faq_title: 'Preguntas Comunes',
  home_faq_subtitle: 'Todo lo que necesitas saber sobre cómo empezar y ganar.',
  home_faq_no_data: 'No se encontraron preguntas.',

  // Trust Bar
  home_trust_badge: 'Confianza Global',
  home_trust_title: 'Confiado por marcas líderes',
  home_trust_desc: 'Nos asociamos con las plataformas de comercio electrónico más grandes del mundo para proporcionar servicios de promoción verificados.',

  // Feature Section
  feature_1_title: 'Pagos Instantáneos',
  feature_1_desc: 'Recibe tus ganancias al instante después de completar el pedido. Retira en cualquier momento sin retrasos.',
  feature_1_detail_1: 'Crédito de comisión en tiempo real',
  feature_1_detail_2: 'Múltiples opciones de retiro',
  feature_1_detail_3: 'Sin umbral mínimo',
  feature_2_title: 'Plataforma Segura',
  feature_2_desc: 'El cifrado de nivel bancario protege tus datos y ganancias. Confiado por miles de usuarios en todo el mundo.',
  feature_2_detail_1: 'Cifrado SSL habilitado',
  feature_2_detail_2: 'Autenticación de dos factores',
  feature_2_detail_3: 'Auditorías de seguridad regulares',
  feature_2_detail_4: 'Privacidad de datos garantizada',
  feature_3_title: 'Horarios Flexibles',
  feature_3_desc: 'Trabaja cuando quieras, donde quiera que estés. Completa pedidos a tu ritmo sin horario fijo.',
  feature_3_detail_1: 'Sin horas de trabajo fijas',
  feature_3_detail_2: 'Trabaja desde cualquier lugar',
  feature_3_detail_3: 'Elige tu propio ritmo',
  feature_3_detail_4: 'Disponibilidad fines de semana',
  feature_4_title: 'Ganancias Progresivas',
  feature_4_desc: 'Desbloquea tasas de comisión más altas a medida que completas más pedidos. Aumenta tus ingresos con cada actualización de nivel.',
  feature_4_detail_1: 'Tasas de comisión basadas en niveles',
  feature_4_detail_2: 'Actualizaciones de nivel automáticas',
  feature_4_detail_3: 'Recompensas por rendimiento',
  feature_5_title: 'Plataforma Global',
  feature_5_desc: 'Trabaja con marcas internacionales desde cualquier parte del mundo. Soporte multi-moneda incluido.',
  feature_5_detail_1: 'Disponible en todo el mundo',
  feature_5_detail_2: 'Soporte multi-moneda',
  feature_5_detail_3: 'Métodos de pago locales',
  feature_6_title: 'Soporte 24/7',
  feature_6_desc: 'Nuestro dedicado equipo de soporte siempre está listo para ayudar. Obtén asistencia vía chat en vivo, correo electrónico o teléfono.',
  feature_6_detail_1: 'Chat en vivo disponible',
  feature_6_detail_2: 'Soporte por correo 24/7',
  feature_6_detail_3: 'Asistencia telefónica',
  feature_6_detail_4: 'FAQ completo',
  feature_7_title: 'Programa de Referidos',
  feature_7_desc: 'Gana ingresos extra invitando amigos. Obtén comisiones de por vida de las ganancias de tus referidos.',
  feature_7_detail_1: 'Ganancias por referidos de por vida',
  feature_7_detail_2: 'Referidos ilimitados',
  feature_7_detail_3: 'Herramientas para compartir fáciles',
  feature_7_detail_4: 'Incentivos de bonificación',
  feature_8_title: 'Multi-Moneda',
  feature_8_desc: 'Soporte para las principales monedas y métodos de pago. Elige lo que mejor funcione para ti.',
  feature_8_detail_1: 'Soporte para USD, EUR, GBP',
  feature_8_detail_2: 'Transferencia bancaria disponible',
  feature_8_detail_3: 'Integración de e-wallet',
  feature_8_detail_4: 'Opciones cripto próximamente',
  feature_9_title: 'Notificaciones Instantáneas',
  feature_9_desc: 'Mantente actualizado con alertas en tiempo real para nuevos pedidos, ganancias y actividades de la cuenta.',
  feature_9_detail_1: 'Notificaciones push',
  feature_9_detail_2: 'Alertas por correo',
  feature_9_detail_3: 'Actualizaciones por SMS',
  feature_9_detail_4: 'Mensajes en la aplicación',

  // Home Page Additional Sections
  home_how_it_works_badge: 'Proceso Simple',
  home_how_it_works_title: 'Cómo Funciona',
  home_how_it_works_subtitle: 'Empieza a ganar en 4 sencillos pasos. No necesitas experiencia, solo sigue el proceso y mira cómo crecen tus ganancias.',
  home_cta_ready_title: '¿Listo para empezar tu viaje?',
  home_cta_ready_desc: 'Únete a miles de usuarios que ya ganan a diario. ¡Tu primera comisión está a solo unos minutos!',
  home_cta_avg_time: 'Tiempo promedio para la primera ganancia:',
  home_cta_15_mins: '15 minutos',
  home_cta_new_users: 'Nuevos usuarios hoy:',

  // CTA Section (Premium)
  home_cta_limit_spots: 'Cupos Limitados este Mes',
  home_cta_main_title: 'Empieza a Ganar Dinero',
  home_cta_today: '¡Hoy mismo!',
  home_cta_main_desc: 'Únete a miles de usuarios que ya ganan comisiones diarias. Sin experiencia previa, horarios flexibles, pagos instantáneos. Tu libertad financiera comienza aquí.',
  home_cta_spots_remaining: 'Cupos Restantes',
  home_cta_new_users_today: 'Nuevos Usuarios Hoy',
  home_cta_create_account: 'Crear Cuenta Gratis',
  home_cta_sign_in: 'Iniciar Sesión',
  home_cta_secure: '100% Seguro',
  home_cta_payouts: 'Pagos en 24-48h',
  home_cta_rating: 'Calificación 4.9/5',
  home_cta_active_users: 'Usuarios Activos',
  home_cta_total_paid: 'Total Pagado',
  home_cta_orders_done: 'Tareas completadas',
  home_cta_satisfaction: 'Satisfacción',
  home_cta_guarantee_title: 'Garantía de Reembolso',
  home_cta_guarantee_desc: '¿No satisfecho? Recupera tu depósito en 7 días',

  // Footer Branding & Extras
  footer_brand_desc: 'La plataforma líder mundial en promoción de comercio electrónico. Únete hoy a nuestra red global de promotores y empieza a ganar comisiones de las mejores marcas.',
  footer_ssl_secure: 'SSL Protegido',
  footer_aes_256: 'Cifrado AES-256',
  footer_cookie_policy: 'Política de Cookies',
  footer_disclaimer: 'Aviso Legal',
  footer_all_rights: 'Todos los derechos reservados.',

  // Announcements
  announcement_withdrawal_delay_title: 'Retraso en el procesamiento de retiros',
  announcement_withdrawal_delay_summary: 'Los retiros pueden tardar hasta 72 horas debido al alto volumen. Por favor, planifica con antelación.',
  announcement_date_june_14: '14 de junio, 2025',

  // How It Works Steps
  step_1_title: 'Regístrate',
  step_1_desc: 'Crea tu cuenta en menos de 2 minutos.',
  step_1_detail_1: 'Ingresa tu información básica',
  step_1_detail_2: 'Verifica tu dirección de correo',
  step_1_detail_3: 'Asegura tu cuenta',
  step_1_detail_4: 'Acceso inmediato al panel',
  step_2_title: 'Elige Tarea',
  step_2_desc: 'Selecciona entre las tareas de promoción disponibles.',
  step_2_detail_1: 'Filtra por plataforma',
  step_2_detail_2: 'Ver tasas de comisión',
  step_2_detail_3: 'Acepta múltiples tareas',
  step_2_detail_4: 'Actualizaciones de tareas en tiempo real',
  step_3_title: 'Completa Tarea',
  step_3_desc: 'Completa las tareas según las instrucciones.',
  step_3_detail_1: 'Instrucciones fáciles de seguir',
  step_3_detail_2: 'Envío rápido de tareas',
  step_3_detail_3: 'Verificación automática',
  step_3_detail_4: 'Interfaz amigable para móviles',
  step_4_title: 'Gana y Retira',
  step_4_desc: 'Obtén el pago por cada tarea completada.',
  step_4_detail_1: 'Seguimiento de ganancias en tiempo real',
  step_4_detail_2: 'Umbral mínimo de retiro bajo',
  step_4_detail_3: 'Múltiples métodos de pago',
  step_4_detail_4: 'Soporte de retiros 24/7',

  // Redesigned Footer
  footer_stay_loop_title: 'Mantente al tanto',
  footer_stay_loop_desc: 'Recibe las últimas actualizaciones, consejos y ofertas exclusivas directamente en tu bandeja de entrada.',
  footer_subscribe: 'Suscribirse',
  footer_subscribe_placeholder: 'Introduce tu correo electrónico',
  footer_trusted_secure: 'CONFIABLE Y SEGURO:',
  footer_ssl_secured: 'Seguridad SSL',
  footer_ssl_secured_desc: 'SSL de 256 bits',
  footer_aes_encryption: 'Cifrado AES-256',
  footer_aes_encryption_desc: 'Nivel bancario',
  footer_kyc_compliant: 'Cumple KYC',
  footer_kyc_compliant_desc: 'Verificado',
  footer_gdpr_compliant: 'Cumple GDPR',
  footer_gdpr_compliant_desc: 'Datos Protegidos',
  footer_iso_certified: 'ISO 27001',
  footer_iso_certified_desc: 'Certificado',
  footer_platform: 'PLATAFORMA',
  footer_support: 'SOPORTE',
  footer_legal: 'LEGAL',
  footer_help_center: 'Centro de ayuda',
  footer_contact_us: 'Contáctanos',
  footer_payments_label: 'Pagos:',
  home_live_activity_title: 'Actividad de la Plataforma en Vivo',
  home_recent_activity_title: 'Actividad Reciente',
  home_total_commissions_paid: 'Total de Comisiones Pagadas',
  home_active_users_online: 'Usuarios Activos en Línea',
  home_tasks_completed_today: 'Tareas Completadas Hoy',
  account_security_row_title: 'Configuración de Seguridad',
  security_login_pw: 'Contraseña de Inicio de Sesión',
  security_login_pw_desc: 'Cambia la contraseña de inicio de sesión de tu cuenta',
  security_change_btn: 'Cambiar',
  security_set_withdrawal_pw_title: 'Establecer Contraseña de Retiro',
  security_set_withdrawal_pw_desc: 'Crea un PIN separado para autorizar retiros',
  security_set_withdrawal_pw_btn: 'Establecer PIN',
  security_change_withdrawal_pw_title: 'Cambiar Contraseña de Retiro',
  security_change_withdrawal_pw_desc: 'Actualiza tu PIN de retiro existente',
  security_change_withdrawal_pw_btn: 'Cambiar',
  security_modal_set_withdrawal_title: 'Establecer Contraseña de Retiro',
  security_modal_set_withdrawal_subtitle: 'Este PIN será requerido cada vez que realices un retiro.',
  security_modal_change_withdrawal_title: 'Cambiar Contraseña de Retiro',
  security_field_current_pin: 'PIN de Retiro Actual',
  security_field_new_pin: 'Nuevo PIN de Retiro',
  security_field_new_pin_6: 'Nuevo PIN de Retiro (6 dígitos)',
  security_field_confirm_pin: 'Confirmar PIN',
  security_field_confirm_new_pin: 'Confirmar Nuevo PIN',
  security_placeholder_pin_dots: '......',
  security_pw_current: 'Contraseña Actual',
  account_security_tips_title: 'Recomendaciones de Seguridad',
  account_security_tips_desc: 'Mejore la protección de su cuenta siguiendo estas sencillas prácticas recomendadas.',
  tip_password_title: 'Contraseña Segura',
  tip_password_desc: 'Utilice una combinación de letras, números y símbolos para garantizar que su cuenta permanezca segura.',
  tip_two_factor_title: 'Verificación de Identidad',
  tip_two_factor_desc: 'Mantenga actualizada su información de contacto para recibir notificaciones de seguridad importantes.',
  tip_logout_title: 'Cerrar Sesión Regularmente',
  tip_logout_desc: 'Cierre siempre la sesión de su cuenta cuando utilice ordenadores públicos o compartidos.',
  tip_sharing_title: 'Nunca Comparta el Acceso',
  tip_sharing_desc: 'Nuestro equipo de soporte nunca le pedirá su contraseña. Nunca comparta sus credenciales con nadie.',

  // Solicitudes de Pedido
  order_requests_title: 'Solicitudes de Pedido',
  order_requests_desc: 'Envíe una solicitud para una nueva tarea o un pedido personalizado. El administrador revisará y asignará tareas basándose en su solicitud.',
  order_requests_new_btn: 'Solicitar Nuevo Pedido',
  order_requests_table_id: 'ID de Solicitud',
  order_requests_table_data: 'Detalles de la Solicitud',
  order_requests_table_status: 'Estado',
  order_requests_table_date: 'Enviado el',
  order_requests_table_actions: 'Acciones',
  order_requests_cancel: 'Cancelar',
  order_requests_cancel_confirm: '¿Está seguro de que desea cancelar esta solicitud de pedido?',
  order_requests_cancel_success: 'Solicitud de pedido cancelada con éxito.',
  order_requests_create_success: 'Solicitud de pedido enviada con éxito.',
  order_requests_modal_title: 'Enviar Nueva Solicitud de Pedido',
  order_requests_modal_desc: 'Por favor, proporcione información detallada sobre el pedido que desea solicitar.',
  order_requests_field_data: 'Datos de la Solicitud de Pedido',
  order_requests_field_placeholder: 'p. ej.: Quiero solicitar un pedido personalizado para el Paquete Premium.',
  order_requests_btn_submit: 'Enviar Solicitud',
  order_requests_btn_submitting: 'Enviando...',
  order_requests_empty: 'No se encontraron solicitudes de pedido.',
  order_requests_status_pending: 'Pendiente',
  order_requests_status_approved: 'Aprobado',
  order_requests_status_rejected: 'Rechazado',
  order_requests_status_cancelled: 'Cancelado',
  order_requests_terms_title: 'Términos Obligatorios de Pedido',
  order_requests_term_1: 'Los nuevos pedidos se asignarán dentro de las 24 a 48 horas posteriores a la aprobación.',
  order_requests_term_2: 'Una vez liberados, los pedidos no pueden cancelarse, pausarse ni modificarse.',
  order_requests_term_3: 'Todos los pedidos asignados deben completarse antes de realizar un retiro.',
  order_requests_term_4: 'El incumplimiento de la finalización de los pedidos puede afectar su reputación en la cuenta.',
  order_requests_term_5: 'Esta solicitud es final y no se puede revertir después del envío.',
  order_requests_policy_title: 'Política de No Cancelación',
  order_requests_policy_desc: 'Al enviar esta solicitud, usted reconoce que el nuevo lote de pedidos es irrevocable. Una vez confirmado por nuestro sistema, no se permitirá ninguna cancelación, modificación ni reembolso bajo ninguna circunstancia.',
  order_requests_accept_terms: 'He leído y entiendo completamente los términos anteriores. Reconozco que una vez enviada, esta solicitud de pedido no puede cancelarse ni modificarse, y acepto completar todos los pedidos asignados.',

  // Orders Page (New Sections)
  orders_withdrawal_policy: 'Política de Retiro',
  orders_unlock_req: 'Requisitos de Desbloqueo',
  orders_unlock_desc: 'Complete su primer lote de {{count}} pedidos para desbloquear permanentemente los retiros. Este requisito único garantiza la integridad de la plataforma y evita el abuso.',
  orders_daily_limits: 'Límites Diarios de Pedidos',
  orders_daily_limit_1: '{{count}} pedidos por lote: debe completar todos antes de solicitar el siguiente',
  orders_daily_limit_2: 'Máximo de {{count}} lotes por día ({{total}} pedidos/día)',
  orders_comm_rates: 'Tasas de Comisión',
  orders_comm_rates_desc: 'Las tasas se determinan según la plataforma y el saldo actual de su billetera:',
  orders_payout_timeline: 'Cronograma de Pagos',
  orders_payout_desc: 'Los retiros se procesan en un plazo de 24 a 48 horas. Las transferencias bancarias pueden tardar de 3 a 5 días hábiles. Los retiros de criptomonedas son instantáneos.',
  orders_processing_fee: 'Se aplica una tarifa de procesamiento del {{fee}}% a todos los retiros para cubrir los costos de transacción.',
  orders_tips_title: 'Consejos para el Éxito',
  orders_tips_1: 'Complete pedidos diariamente para crear impulso y maximizar las ganancias',
  orders_tips_2: 'Permanezca en la página durante el procesamiento para asegurar una finalización adecuada',
  orders_tips_3: 'Verifique su billetera regularmente para seguir el crecimiento de las comisiones',
  orders_tips_4: 'Recomiende amigos para ganar comisiones de bonificación por sus pedidos',
  orders_tips_5: 'Póngase en contacto con el soporte inmediatamente si tiene algún problema',
  orders_batch_approx: '{{count}} pedidos/lote × promedio ${{avg}} = aproximadamente ${{total}} por lote',

  // Settings
  settings_page_title: 'Ajustes',
  settings_page_desc: 'Administre su seguridad, privacidad y preferencias',
  settings_kyc_label: 'Verificación KYC',
  settings_kyc_desc: 'Verificación de identidad',
  settings_security_label: 'Seguridad',
  settings_security_desc: 'Gestión de contraseñas',
  settings_language_label: 'Idioma',
  settings_language_desc: 'Preferencias regionales',
  // Support
  support_btn_send: 'Enviar respuesta',
  support_edit_message: 'Editar mensaje',
  support_delete_message: 'Eliminar mensaje',
  support_delete_confirm: '¿Estás seguro de que quieres eliminar este mensaje?',
  support_message_updated: 'Mensaje actualizado con éxito',
  support_message_deleted: 'Mensaje eliminado con éxito',
  support_err_already_read: 'No se puede editar un mensaje después de que haya sido visto.',
  support_status_read: 'Leído',
  support_status_unread: 'Enviado',
  // Modal de Depósito
  deposit_modal_title_method: "Seleccionar método de pago",
  deposit_modal_title_gateway: "Seleccionar monedero cripto",
  deposit_modal_title_plan: "Seleccionar plan de depósito",
  deposit_modal_title_details: "Detalles del depósito",
  deposit_modal_step_method: "Método",
  deposit_modal_step_gateway: "Monedero",
  deposit_modal_step_plan: "Plan",
  deposit_modal_step_details: "Detalles",
  deposit_modal_credit_card: "Tarjeta de crédito / débito",
  deposit_modal_bank_transfer: "Transferencia bancaria",
  deposit_modal_ewallet: "Billetera electrónica",
  deposit_modal_digital_currency: "Moneda digital",
  deposit_modal_not_available: "No disponible en su región",
  deposit_modal_available_recommended: "Disponible — Recomendado",
  deposit_modal_back_to_method: "Volver a los métodos de pago",
  deposit_modal_back_to_gateway: "Volver a la lista de monederos",
  deposit_modal_back_to_plan: "Volver a los planes",
  deposit_modal_digital_selected: "Moneda digital seleccionada",
  deposit_modal_digital_hint: "Elija su monedero cripto para recibir la dirección e instrucciones.",
  deposit_modal_loading_wallets: "Cargando monederos...",
  deposit_modal_no_wallets: "No hay monederos cripto disponibles.",
  deposit_modal_loading_plans: "Cargando planes...",
  deposit_modal_no_plans: "No hay planes de depósito disponibles en este momento.",
  deposit_modal_duration: "Duración",
  deposit_modal_amounts_profits: "Cantidades y ganancias",
  deposit_modal_amount_label: "Cantidad",
  deposit_modal_profit_label: "Ganancia",
  deposit_modal_benefits: "Beneficios",
  deposit_modal_continue: "Continuar",
  deposit_modal_transfer_details: "Detalles de transferencia para {{name}}",
  deposit_modal_deposit_amount: "Cantidad del depósito",
  deposit_modal_amount_fixed: "Cantidad fijada por su plan seleccionado",
  deposit_modal_txn_id: "ID de transacción",
  deposit_modal_txn_optional: "(Opcional)",
  deposit_modal_txn_placeholder: "ej. 0x1a2b3c4d...",
  deposit_modal_screenshot: "Captura de pantalla",
  deposit_modal_upload_proof: "Subir comprobante de pago",
  deposit_modal_upload_hint: "PNG, JPG, JPEG — Máx 5MB",
  deposit_modal_comments: "Comentarios",
  deposit_modal_comments_placeholder: "Cualquier información extra...",
  deposit_modal_notice: "Después de enviar, nuestro equipo verificará su pago y acreditará su cuenta en 5-30 minutos.",
  deposit_modal_confirm: "Confirmar depósito",
  deposit_modal_submitting: "Enviando...",
  deposit_modal_err_fields: "Por favor complete todos los campos requeridos",
  deposit_modal_err_submit: "Ocurrió un error durante el envío",
  deposit_modal_success: "¡Depósito solicitado con éxito!",
  deposit_modal_err_plans: "Error al cargar los planes de depósito",
  deposit_modal_err_wallets: "Error al cargar los métodos de pago",
  deposit_modal_new_to_crypto: "New to crypto? Learn how to buy digital currency",
  deposit_modal_crypto_label: "Cripto",
  orders_insufficient_balance: "Insufficient Balance",
  orders_balance_gap_msg1: "Your current balance is not enough to complete this order.",
  orders_balance_gap_msg2_start: "Please add",
  orders_balance_gap_msg2_end: "to proceed and unlock your commission.",
  orders_btn_add_funds: "Add Funds",
  withdrawal_restricted_support: "Contactar Soporte",
  deposit_modal_plan_description_hint: "Add the deposit for getting the order and earn the commission from order process",
};
